import React from 'react';
import { useNavigate } from 'react-router-dom';

const accountingMenu = [
    {
    title: 'Records',
    accounting: [
      { name: 'Journal', path: '/journal', new: false, soon: false },
      { name: 'Money In', path: '/money-in', new: false, soon: false },
      { name: 'Money Out', path: '/money-out', new: false, soon: false },
    ]
  }
];

export default function Accounting() {
  const navigate = useNavigate();

  return (
    <div className="p-6 text-white">
      <div>
        <h1 className="text-3xl font-bold">Accounting</h1>
        <p className="text-sm text-gray-400">Record your financial transactions.</p>
      </div><br/>

      {accountingMenu.map((category, idx) => (
        <div key={idx} className="mb-8">
          <h2 className="text-lg font-semibold mb-3">{category.title}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {category.accounting.map((menu, i) => (
              <div
                key={i}
                onClick={() => navigate(menu.path)}
                className="bg-[#1f1f1f] hover:bg-purple-700 hover:text-white transition p-4 rounded-lg cursor-pointer border border-gray-700"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v8m-6 0a2 2 0 002 2h2a2 2 0 002-2" />
                  </svg>
                  <span>{menu.name}</span>
                  {menu.new && (
                  <span className="bg-green-500 text-white text-xs px-2 py-0.5 rounded-full">New!</span>
                )}
                {menu.soon && (
                  <span className="bg-orange-500 text-white text-xs px-2 py-0.5 rounded-full">Soon!</span>
                )}
                </div>
                
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
